import "../scss/student.scss";

(() => {
    let studentContentScrollIndicator = () => {
        let studentContent = document.getElementById("student-content");
        let scrollIndicator = document.getElementById("scroll-indicator");
        scrollIndicator.style.opacity = 0;

        setTimeout(() => {
            scrollIndicator.style.display = "none";
        }, 1000);

        studentContent.removeEventListener('scroll', studentContentScrollIndicator);
    }

    let studentContent = document.getElementById("student-content");
    studentContent.addEventListener('scroll', studentContentScrollIndicator);
})()